import React from 'react';
import { CreditCard } from 'lucide-react';
import { PaymentTypeFilter } from '../types';
import './PaymentTypeFilter.css';

interface PaymentTypeFilterProps {
  selectedType: PaymentTypeFilter;
  onTypeChange: (type: PaymentTypeFilter) => void;
  recurrentCount: number;
  packageCount: number;
  totalCount: number;
}

const PaymentTypeFilterComponent: React.FC<PaymentTypeFilterProps> = ({
  selectedType,
  onTypeChange,
  recurrentCount,
  packageCount,
  totalCount
}) => {
  const typeOptions = [
    { 
      value: 'all' as PaymentTypeFilter, 
      label: 'Todos los Tipos', 
      count: totalCount,
      className: 'all'
    },
    { 
      value: 'recurrent' as PaymentTypeFilter, 
      label: 'Cliente Recurrente', 
      count: recurrentCount,
      className: 'recurrent'
    },
    { 
      value: 'package' as PaymentTypeFilter, 
      label: 'Cliente de Paquete', 
      count: packageCount,
      className: 'package'
    }
  ];

  return (
    <div className="payment-type-filter">
      <div className="payment-type-filter-header">
        <CreditCard size={18} />
        <span>Filtrar por Tipo de Pago:</span>
      </div>
      <div className="payment-type-filter-options">
        {typeOptions.map((option) => (
          <button
            key={option.value}
            className={`payment-type-filter-button ${option.className} ${
              selectedType === option.value ? 'active' : ''
            }`}
            onClick={() => onTypeChange(option.value)}
          >
            <span className="payment-type-label">{option.label}</span>
            <span className="payment-type-count">({option.count})</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PaymentTypeFilterComponent;
